/* CM PDP — galerie swipe-hint: un singur nudge vizual (translateX peek->revenire) dupa 2.5s.
   Stop la orice touch/click/swipe. Nu porneste daca userul a derulat deja pagina. Respecta reduced-motion. */
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function init(){
    var grids = document.querySelectorAll('.slider__grid');
    var grid = null;
    for (var i=0;i<grids.length;i++){ if (grids[i].children.length > 1){ grid = grids[i]; break; } }
    if (!grid) return; // o singura imagine -> niciun nudge
    var slider = grid.closest('.slider') || grid;
    var orig = grid.style.transform || '';
    var aborted=false, started=false;
    var startY = window.scrollY || window.pageYOffset || 0;
    var EVTS = ['touchstart','pointerdown','mousedown','wheel','keydown'];
    function cleanup(){ EVTS.forEach(function(ev){ slider.removeEventListener(ev, abort, true); }); }
    function reset(){ grid.style.transition='transform .25s ease'; grid.style.transform=orig; }
    function abort(){ if(aborted) return; aborted=true; if(started) reset(); cleanup(); }
    EVTS.forEach(function(ev){ slider.addEventListener(ev, abort, {capture:true, passive:true}); });
    setTimeout(function(){
      if (aborted) return;
      if (Math.abs((window.scrollY||window.pageYOffset||0) - startY) > 24){ cleanup(); return; } // a derulat pagina
      if (slider.scrollLeft > 4){ cleanup(); return; } // a glisat deja galeria
      started = true;
      var peek = Math.min(34, Math.round(grid.clientWidth * 0.12)) || 30;
      grid.style.transition = 'transform .5s cubic-bezier(.4,0,.2,1)';
      grid.style.transform = 'translateX(-' + peek + 'px)';
      setTimeout(function(){
        if (aborted) return;
        grid.style.transform = 'translateX(0)';
        setTimeout(function(){ if(!aborted){ grid.style.transition=''; grid.style.transform=orig; } cleanup(); }, 560);
      }, 580);
    }, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
